module.exports = __webpack_public_path__ + "img/SEJ_Eventos_agregar.23b8eca8.svg";